export default "__VITE_ASSET__EOTCqFRI__"